import { useEffect, useState } from "react";
import { useStores } from "../../use.store";
import { observer } from "mobx-react-lite";
import { delay, getAppLogo } from "../../helpers";
import { getPoiShapes, loadMap } from "@adactiveasia/adsign-map";
import Div100vh from "react-div-100vh";

const SplashPage = () => {
  const { mapStore, mainStore } = useStores();
  const [stepLoading, setStepLoading] = useState(0);
  const [showButtonStart, setShowButtonStart] = useState(false);
  const [welcomeText, setWelcomeText] = useState();
  const stepsLoading = 4;

  const queryParams = new URLSearchParams(location.search);
  const poiIdParams = queryParams?.get("poiId");

  // init adsign data
  useEffect(() => {
    setShowButtonStart(false);
    const loadData = async () => {
      if (mapStore?.information) {
        mapStore.information.forEach((info) => {
          if (info?.name === "Welcome Page - Text") {
            setWelcomeText(info?.description);
          } else if (
            info?.name === "Logo" &&
            info?.categoryId === "687e019ffb979e750849ae6d"
          ) {
            mainStore.setAppLogo(info?.files?.[0]?.logo);
          } else if (
            info?.name === "Background" &&
            info?.categoryId === "687e019ffb979e750849ae6d"
          ) {
            mainStore.setAppBackground(info?.files?.[0]?.logo);
          } else if (info?.name === "Homepage - Header") {
            mainStore.setHomeAttr(info?.files?.[0]?.logo, info?.description);
          } else if (info?.name === "Navigation - Highlights") {
            mainStore.setHomeMenuHighlightAttr(
              info?.files?.[0]?.logo,
              info?.description,
            );
          } else if (info?.name === "Navigation - General Enquiries") {
            mainStore.setHomeMenuGeneralEnquiriesAttr(
              info?.files?.[0]?.logo,
              info?.description,
            );
          } else if (info?.name === "Navigation - Wayfinder") {
            mainStore.setHomeMenuWayfinderAttr(
              info?.files?.[0]?.logo,
              info?.description,
            );
          } else if (info?.name === "Navigation - Resources") {
            mainStore.setHomeMenuResourcesAttr(
              info?.files?.[0]?.logo,
              info?.description,
            );
          } else if (info?.name === "Pop Out Message") {
            mainStore.setPopupMessage(info?.description);
          } else if (info?.name === "Pop Out Form Header") {
            mainStore.setPopupFormHeader(info?.description);
          } else if (info?.name === "Pop Out Form Header Rating Label") {
            mainStore.setPopupFormHeaderRatingLabel(info?.description);
          } else if (info?.name === "Pop Out Form Header Comments Label") {
            mainStore.setPopupFormHeaderCommentLabel(info?.description);
          } else if (info?.name === "Pop Out Form Thank you Message") {
            mainStore.setPopupFormHeaderThankouMsg(info?.description);
          } else if (info?.name === "Weather External Link") {
            mainStore.setWeatherLink(info?.description);
          } else if (info?.name === "General Feedback Icon") {
            mainStore.setSmileFeedbackIcon(info?.files?.[0]?.logo);
          } else if (info?.name === "Form Feedback Title") {
            mainStore.setFormFeedbackTitle(info?.files?.[0]?.logo);
          } else if (info?.name === "Form Feedback Title") {
            mainStore.setFormFeedbackTitle(info?.description);
          } else if (info?.name === "Form Feedback Field Name") {
            mainStore.setFormFeedbackFieldName(info?.description);
          } else if (info?.name === "Form Feedback Thank You Message") {
            mainStore.setFormFeedbackThankYouMsg(info?.description);
          } else if (info?.name === "Form Feedback Thank You Image") {
            mainStore.setFormFeedbackThankYouImg(info?.files?.[0]?.logo);
          }
        });
      }
    };
    const loadConfig = async () => {
      const config = await fetch("/config.json");
      const json = await config.json();

      if (json) {
        mainStore.setConfig(json);
      } else {
        console.error("Failed to load config!");
      }
    };

    const loadStartPoi = async () => {
      // if (poiIdParams) {
      //   localStorage.setItem("poiIdParams", poiIdParams);
      // }
      // const poiId = await localStorage.getItem("poiIdParams");
      if (mapStore?.pois && poiIdParams) {
        const prefixStartPoi =
          mapStore.pois && mapStore.pois.find(({ _id }) => _id === poiIdParams);

        const shape = getPoiShapes(mapStore, prefixStartPoi._id)[0];

        // localStorage.setItem("poiId", poiId);

        mainStore.setSelectedStartPoi(prefixStartPoi);
        mainStore.setSelectedStartShape(shape);
      }
    };

    const init = async () => {
      await delay(250);
      await loadConfig();
      setStepLoading(1);
      await loadMap(mapStore);
      setStepLoading(2);
      await delay(250);
      await loadData();
      setStepLoading(3);
      await loadStartPoi();
      setStepLoading(4);
    };

    init();
  }, []);

  const progress = Math.min((stepLoading / stepsLoading) * 100, 100);
  const isFinished = stepLoading === stepsLoading;

  return (
    <Div100vh className="relative overflow-hidden">
      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center w-full h-full px-[40px] bg-[#215732]">
        {isFinished ? (
          <>
            <img
              src={getAppLogo(mainStore.config, mainStore.appLogo)}
              alt="logo"
              className="w-[70%] max-w-[242px] mb-24"
            />
            <span className="text-white text-[40px] text-center mb-24">
              {welcomeText ?? "Welcome to National Orchid Gardens!"}
            </span>
          </>
        ) : (
          <>
            <span className="text-white">{Math.round(progress)}%</span>{" "}
            <span className="text-white">Preparing your experience...</span>
          </>
        )}
        {stepLoading === stepsLoading && (
          <button
            class="bg-[#A89200] text-white py-3 rounded w-[250px]"
            onClick={() => mainStore.setAppLoaded(true)}
          >
            Get Started
          </button>
        )}
      </div>
    </Div100vh>
  );
};

export default observer(SplashPage);
